import React from 'react';
import { howItWorks } from '../data/mockData';

const HowItWorksSection = () => {
  return (
    <section id="como-funciona" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Como <span className="text-orange-500">Funciona?</span>
          </h2>
          <p className="text-xl text-gray-600">
            Um método simples e eficiente em 4 passos para sua aprovação
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorks.map((step, index) => (
              <div 
                key={step.step}
                className="relative"
              >
                {/* Connection Line (hidden on mobile, shown on desktop) */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-1/2 w-full h-1 bg-gradient-to-r from-orange-500 to-orange-300 z-0"></div>
                )}

                {/* Step Card */}
                <div className="relative z-10 bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border-2 border-gray-100 hover:border-orange-500 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  {/* Step Number */}
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mb-6 shadow-lg mx-auto">
                    {step.step}
                  </div>

                  {/* Step Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>

                  {/* Step Description */}
                  <p className="text-gray-700 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Visual Example */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-3xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Revisão Ativa com Flashcards
                </h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  O método de flashcards é comprovado cientificamente como uma das formas mais eficientes de aprendizado. 
                  Ao invés de apenas ler, você testa ativamente seu conhecimento, fortalecendo as conexões neurais.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center space-x-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                    <span className="text-gray-700">Memorização de longo prazo</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                    <span className="text-gray-700">Identificação rápida de gaps</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm">✓</span>
                    <span className="text-gray-700">Revisão eficiente em minutos</span>
                  </li>
                </ul>
              </div>

              <div className="relative">
                <img 
                  src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&q=80" 
                  alt="Flashcards digitais"
                  className="rounded-2xl shadow-2xl"
                />
                {/* Floating Card Mockup */}
                <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow-2xl p-4 transform rotate-3 border-2 border-orange-500">
                  <div className="text-sm font-bold text-gray-900 mb-1">
                    Direito Penal
                  </div>
                  <div className="text-xs text-gray-600">
                    Card 1 de 150
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <button 
            onClick={() => {
              const element = document.getElementById('produtos');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Começar Agora com 50% OFF
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
